import { supabase } from "@/integrations/supabase/client";
import type { LoginBackgrounds } from "@/lib/loginBackground";
import { z } from "zod";

const responseSchema = z.object({
  appName: z.string(),
  backgrounds: z.object({ loginLight: z.string().nullable().optional(), loginDark: z.string().nullable().optional() }),
});

export async function getPublicLoginBackgrounds(appName: string): Promise<LoginBackgrounds> {
  const { data, error } = await supabase.functions.invoke("public-login-appearance", { body: { appName } });
  if (error) throw new Error("Login appearance unavailable");
  const result = responseSchema.parse(data);
  if (result.appName !== appName) throw new Error("Unexpected app appearance");
  return result.backgrounds;
}